import classNames from 'classnames';
import React, { FC, HTMLAttributes } from 'react';
import { t } from 'utils';
import styles from './UsageBadge.module.scss';

export interface IUsageBadge extends HTMLAttributes<HTMLDivElement> {
  isPublic: boolean;
}

const UsageBadge: FC<IUsageBadge> = (props) => {
  const { className, isPublic } = props;
  const rootClassName = classNames(styles.root, className, {
    [styles.public]: isPublic,
  });

  return <div className={rootClassName}>{t(isPublic ? 'public.app' : 'private.app')}</div>;
};

export default UsageBadge;
